import { Component, Inject} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-cancel-contract',
  templateUrl: './modal-cancel-contract.component.html',
  styleUrls: ['./modal-cancel-contract.component.scss']
})
export class ModalCancelContractComponent {

  constructor(
    public dialogRef: MatDialogRef<ModalCancelContractComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { subtitle: string}
  ) { }

  public handleCancel(close: boolean): void {
    this.dialogRef.close(close);
  }
}
